import styled from 'styled-components';
import adminBg from '../Assets/bg/adminbg.jpg';

export const EditLabel = styled.span`
  font-size: 13px;
  margin-left: 1px;
  visibility: hidden; 
  position: absolute;
  left: 25px;
  top: 0;
  bottom: 1px;
  opacity: 0;
   background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#fff')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
  padding: 1px 8px; 
  border-radius: 5px; /* Optional: rounded corners */
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1); 
  transition: opacity 0.3s ease;
`;


export const ChevronWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  padding: 8px;

  &:hover ${EditLabel} {
    visibility: visible;
    opacity: 1;
  }
`;

export const ChevronIcon = styled.img`
  width: 20px;
  height: 20px;
`;

